module.exports = __webpack_public_path__ + "static/media/payment3.17c0bcbf.png";